import React from 'react';
import PopupWidget from '../../Calendly';

export const CalendlyLink = ({ offer, tenant }) => {
  return (
    <div>
      <PopupWidget
        url={`${offer.calendlyUrl}`}
        className='button small w-button'
        rootElement={document.getElementById('root')}
        text='Schedule a Call'
        tenantColor={tenant.theme.primaryColor}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/CalendlyLink.js